import { SearchOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import { createStyles } from 'antd-style'

import { FormGrid } from '@eastcoal/formily/components/FormGrid'
import { SchemaSearch } from '@eastcoal/formily/components/SchemaSearch'
import { toJS } from '@eastcoal/formily/exports/reactive'

import { pick } from '../../../utils/object'
import { ThrottleButton } from '../../Button/ThrottleButton'
import { useRemoteTransferStore } from '../Store/hooks/useStore'

import { RemoteTransferSearchFormProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  searchForm: {
    paddingBlock: token.paddingXS,
    paddingInline: token.paddingSM
  }
}))

export const RemoteTransferSearchForm = ({
  onSearch,
  ...restProps
}: RemoteTransferSearchFormProps) => {
  const { searchForm, fetchSearch } = useRemoteTransferStore(state =>
    pick(state, ['searchForm', 'fetchSearch'])
  )

  const search = () => {
    const normalValues = toJS(searchForm.values)
    const params = onSearch?.(normalValues) ?? normalValues
    fetchSearch(params)
  }

  const { styles } = useStyles()

  return (
    <SchemaSearch
      {...restProps}
      className={styles.searchForm}
      form={searchForm}
    >
      <FormGrid.Column>
        <Flex gap={8} vertical={false}>
          <ThrottleButton
            htmlType='submit'
            icon={<SearchOutlined />}
            type='primary'
            onClick={search}
          />
        </Flex>
      </FormGrid.Column>
    </SchemaSearch>
  )
}
